import React from 'react';
import PropTypes from 'prop-types';
import { useDarkMode } from '../contexts/DarkModeContext';
import { Search, Table, Code2 } from 'lucide-react';

function ChatMessageTabs({ selectedTab, setSelectedTab, visibleTabs, insightsLabel = 'Insights' }){
    const { isDarkMode } = useDarkMode();

    const tabDefs = [
      { key: 'data', label: 'Data', icon: Table },
      { key: 'source', label: 'Source', icon: Code2 },
      { key: 'description', label: insightsLabel, icon: Search },
    ];

    return (
        <div className={`flex items-center gap-1 px-4 py-2 border-b ${
            isDarkMode ? 'border-slate-700 bg-slate-800' : 'border-gray-100 bg-white'
        } rounded-t-xl`}>
            {tabDefs
              .filter(tab => visibleTabs.includes(tab.key))
              .map(tab => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
                      selectedTab === tab.key
                        ? (isDarkMode ? 'bg-slate-700 text-white' : 'bg-gray-100 text-gray-900')
                        : (isDarkMode ? 'text-slate-400 hover:text-white hover:bg-slate-700' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50')
                    }`}
                    onClick={() => setSelectedTab(tab.key)}
                  >
                    <Icon className="w-4 h-4" />
                    <span>{tab.label}</span>
                  </button>
                );
              })
            }
        </div>
    );
}

ChatMessageTabs.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
  visibleTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  insightsLabel: PropTypes.string,
};

export default ChatMessageTabs;
